var classof = require('../internals/classof-raw');
var global = require('../internals/global');

module.exports = classof(global.process) == 'process';



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/engine-is-node.js
// module id = 1034
// module chunks = 0